import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "@/context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUserFromCallback } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use ref to prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = window.location.hash;
        const sessionIdMatch = hash.match(/session_id=([^&]+)/);
        
        if (!sessionIdMatch) {
          console.error("No session_id found");
          navigate("/");
          return;
        }

        const sessionId = sessionIdMatch[1];

        // If this browser session was started from the mobile app's
        // /app-login bridge, hand the session_id back to the app instead
        // of signing in on the web. The app exchanges it itself.
        if (sessionStorage.getItem("scoop_app_auth") === "1") {
          sessionStorage.removeItem("scoop_app_auth");
          window.location.replace(`thescoop://auth-callback#session_id=${sessionId}`);
          return;
        }

        // Exchange session_id for session_token
        const response = await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );

        setUserFromCallback(response.data);
        
        // Clear the hash and redirect
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/", { state: { user: response.data } });
        
      } catch (error) {
        console.error("Auth callback error:", error);
        navigate("/");
      }
    };

    processAuth();
  }, [navigate, setUserFromCallback]);

  return (
    <div className="min-h-screen bg-scoop-cream flex items-center justify-center">
      <div className="text-center">
        <div className="font-display text-3xl font-bold text-scoop-ink mb-2">
          The <em className="text-scoop-blue">Scoop</em>
        </div>
        <p className="text-scoop-muted text-sm">Signing you in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
